
          import $$Component from "/home/runner/work/wp-tm-168topgame/wp-tm-168topgame/typescript/pages/Sport.vue?vue&type=script"
          
          import { render } from "/home/runner/work/wp-tm-168topgame/wp-tm-168topgame/typescript/pages/Sport.vue?vue&type=template"
          export * from "/home/runner/work/wp-tm-168topgame/wp-tm-168topgame/typescript/pages/Sport.vue?vue&type=template"
          $$Component.render = render
          export default $$Component